import { render, staticRenderFns } from "./MainNavigationSysAdminUi.vue?vue&type=template&id=454d6b32&"
import script from "./MainNavigationSysAdminUi.vue?vue&type=script&lang=js&"
export * from "./MainNavigationSysAdminUi.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationSysAdminUi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports